<template>
  <vx-card>
    <div class="flex justify-between mb-5 md:mb-0">
      <span class="font-bold" style="font-size: 14px"><i class="dot"></i>{{ title }}</span>
      <vs-select style="width: 80px" v-model="selectYear" autocomplete @change="onChangeYear">
        <vs-select-item v-for="n in _nowYear - 2020 + 1" :key="`graph1_year_${n}`" :value="_nowYear - (n - 1)" :text="`${_nowYear - (n - 1)}년`" />
      </vs-select>
    </div>

    <horizontal-single-bar-graph :max="maxY" :labels="['']" unit="%" :height="86" :current-value="currentValue" />
  </vx-card>
</template>

<script>
import ComparisonBarGraph from "@/components/ComparisonBarGraph";
import HorizontalSingleBarGraph from "@/components/HorizontalSingleBarGraph.vue";
export default {
  name: "SingleYearChartCard",
  components: {HorizontalSingleBarGraph, ComparisonBarGraph },
  props: {
    title: String,
    year: Number,
    currentValue: {
      type: Number,
      default: 0,
    },
    showSum: {
      type: Boolean,
      default: true,
    },
    sum1: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    maxY: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectYear: this.year,
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },

    _nowYear() {
      return new Date().getFullYear();
    },

  },
  methods: {
    onChangeYear(year) {
      this.$emit("change", year);
    },
    sum(values) {
      let sum = 0;
      if (values && values.length > 0) {
        values.map((value) => {
          sum += value;
        });
      }
      return sum;
    },
  },
};
</script>

<style scoped></style>
